import { takeLatest, put, call, select } from 'redux-saga/effects';
import { REMOVE_USER_SAGA } from "../sagaTypes";
import { loaderAction, currentUserAction, searchAction, usersAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getUsersStatisticSagaAction } from "../sagaActions";
import { CURRENT_USER_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/remove_user`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRemoveUser(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(searchAction(''));
            yield put(usersAction([]));
            yield put(getUsersStatisticSagaAction({ establishment: currentEstablishment }));
            yield put(currentUserAction(CURRENT_USER_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherRemoveUser() {
    yield takeLatest(REMOVE_USER_SAGA, workerRemoveUser);
}